import $ from 'jquery';
import VisSenseFactory from 'vissense';

$(() => {
    if ($(".counters-container").length) {
        if ($('.js-counter').length) {
            const VisSense = VisSenseFactory(window);
            $('.js-counter').each(function (index) {
                var counterItem = $(this);
                var counterItemVisibility = VisSense(counterItem[0], {
                    fullyvisible: 1
                });
                counterItemVisibility.monitor({
                    fullyvisible: function () {
                        counterItem.prop('Counter', 0).animate({
                            Counter: counterItem.data('target')
                        }, {
                            duration: 1000,
                            easing: 'swing',
                            step: function (now) {
                                counterItem.text(Math.ceil(now));
                            }
                        });
                    },
                })
                    .start();
            });
        }
    }
});